module.exports = __webpack_public_path__ + "img/refresh.3e908233.svg";